import { Routes } from '@angular/router';
import { authGuard, loginGuard, adminGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () =>
      import('./auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'clients',
        loadComponent: () =>
          import('./components/clients/clients.component').then(m => m.ClientsComponent)
      },
      {
        path: 'clients/create',
        loadComponent: () =>
          import('./components/clients/client-form.component').then(m => m.ClientFormComponent)
      },
      {
        path: 'clients/edit/:id',
        loadComponent: () =>
          import('./components/clients/client-form.component').then(m => m.ClientFormComponent)
      },
      {
        path: 'workflows',
        loadComponent: () =>
          import('./components/workflows/workflows.component').then(m => m.WorkflowsComponent)
      },
      {
        path: 'workflows/create',
        loadComponent: () =>
          import('./components/workflows/workflow-form.component').then(m => m.WorkflowFormComponent)
      },
      {
        path: 'workflows/edit/:id',
        loadComponent: () =>
          import('./components/workflows/workflow-form.component').then(m => m.WorkflowFormComponent)
      },
      {
        path: 'workflows/:id/tasks',
        loadComponent: () =>
          import('./components/workflows/workflow-tasks.component').then(m => m.WorkflowTasksComponent)
      },
      {
        path: 'tasks/:id',
        loadComponent: () =>
          import('./components/tasks/task-detail.component').then(m => m.TaskDetailComponent)
      },
      {
        path: 'vehicles',
        loadComponent: () =>
          import('./components/vehicles/vehicles.component').then(m => m.VehiclesComponent)
      },
      {
        path: 'vehicles/create',
        loadComponent: () =>
          import('./components/vehicles/vehicle-form.component').then(m => m.VehicleFormComponent)
      },
      {
        path: 'vehicles/edit/:id',
        loadComponent: () =>
          import('./components/vehicles/vehicle-form.component').then(m => m.VehicleFormComponent)
      },
      {
        path: 'work-parts',
        loadComponent: () =>
          import('./components/work-parts/work-parts.component').then(m => m.WorkPartsComponent)
      },
      {
        path: 'work-parts/create',
        loadComponent: () =>
          import('./components/work-parts/work-part-form.component').then(m => m.WorkPartFormComponent)
      },
      {
        path: 'work-parts/edit/:id',
        loadComponent: () =>
          import('./components/work-parts/work-part-form.component').then(m => m.WorkPartFormComponent)
      },
      {
        path: 'work-part-templates',
        loadComponent: () =>
          import('./components/work-part-templates/work-part-templates.component').then(m => m.WorkPartTemplatesComponent)
      },
      {
        path: 'work-part-templates/create',
        loadComponent: () =>
          import('./components/work-part-templates/work-part-template-form.component').then(m => m.WorkPartTemplateFormComponent)
      },
      {
        path: 'work-part-templates/edit/:id',
        loadComponent: () =>
          import('./components/work-part-templates/work-part-template-form.component').then(m => m.WorkPartTemplateFormComponent)
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./components/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'admin/tasks',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./components/admin/tasks/admin-tasks.component').then(m => m.AdminTasksComponent)
      }
    ]
  },
  { path: '**', redirectTo: '/login' }
];
